import { FormValidationSchema } from "@/components/Form/types";
import { I_LoginPage } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";

export const loginValidation = (data: I_LoginPage): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
    },
  },
  {
    name: "password",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("password", "required", data),
      },
    },
  },
];
